import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { InteractorResponse } from '../../models/interactor-response';
import { AppConstants } from '../../constants/app-constants';
import { AbstractDashboardApiService } from '../abstract/abstract-dashboard-api-service';
import { DashboardModel } from '../../../store/dashboard/model';

const baseUrl = `/api/dashboard`;

@Injectable()
export class DashboardApiService extends AbstractDashboardApiService {
  private http = inject(HttpClient);

  public load(): Observable<InteractorResponse<DashboardModel>> {
    return this.http.get<InteractorResponse<DashboardModel>>(`${baseUrl}/load`);
  }

  public save(entity: DashboardModel): Observable<InteractorResponse<any>> {
    return this.http.post<InteractorResponse<any>>(`${baseUrl}/save`, entity);
  }

  public uploadBackgroundImage(file: File): Observable<InteractorResponse<any>> {
    let formData: FormData = new FormData();
    formData.append('file', file);

    return this.http.post<InteractorResponse<any>>(`${baseUrl}/uploadBackgroundImage`, formData);
  }

  public deleteBackgroundImage(): Observable<InteractorResponse<any>> {
    return this.http.post<InteractorResponse<any>>(`${baseUrl}/deleteBackgroundImage`, {});
  }
}
